import { createSelector } from 'reselect';

import { RootState } from 'app/store';
import {
  QuestionQueue,
  QuestionQueueAssignment,
  QuestionQueueAsync,
  QuestionQueueHistory,
  QuestionQueueOpportunity,
  QuestionQueueStatus,
} from 'app/queue/domains/question-queue/question-queue-types';

export const selectQuestionQueue = (state: RootState): QuestionQueue => state.questions.queue;

export const selectQuestionQueueStatus = createSelector(
  selectQuestionQueue,
  (queue: QuestionQueue): QuestionQueueStatus => queue.status
);

export const selectQuestionQueueEnabled = createSelector(
  selectQuestionQueueStatus,
  (status: QuestionQueueStatus): boolean => status.enabled
);

export const selectQuestionQueueExpiration = createSelector(
  selectQuestionQueueStatus,
  (status: QuestionQueueStatus): number | null => status.expiresAt
);

export const selectProjectsEnabledInQuestionQueue = createSelector(
  selectQuestionQueueStatus,
  (status: QuestionQueueStatus): { [projectId: string]: boolean } => status.projectEnabledInQueue
);

export const selectQuestionQueueOpportunities = createSelector(
  selectQuestionQueue,
  (queue: QuestionQueue): { [projectID: string]: QuestionQueueOpportunity } => queue.projectOpportunities
);

export const selectQuestionQueueAssignments = createSelector(
  selectQuestionQueue,
  (queue: QuestionQueue): QuestionQueueAssignment[] => queue.assignments
);

export const selectQuestionQueueHistory = createSelector(
  selectQuestionQueue,
  (queue: QuestionQueue): QuestionQueueHistory => queue.history
);

export const selectQuestionQueueAsync = (state: RootState): QuestionQueueAsync => state.questions.queueAsync;

export const selectQuestionQueueHistoryAsync = createSelector(
  selectQuestionQueueAsync,
  (queueAsync) => queueAsync.history
);
